import { useCallback } from 'react'
import { useForm } from 'react-hook-form'
import type { TransferWizardFormValues } from '../types'
import { defaultTransferFormValues } from '../utils/transferFormUtils'

export function useTransferProcessForm() {
  const form = useForm<TransferWizardFormValues>({
    defaultValues: defaultTransferFormValues(),
    mode: 'onChange',
  })
  const { register, watch, reset, setValue, getValues, formState, trigger } = form

  const setValueValidated = useCallback(
    (name: Parameters<typeof setValue>[0], value: Parameters<typeof setValue>[1]) => {
      setValue(name, value, { shouldValidate: true, shouldDirty: true })
    },
    [setValue],
  )

  // eslint-disable-next-line react-hooks/incompatible-library -- react-hook-form watch() is intentionally unmemoizable
  const fkCompanyId = watch('fk_company_id')
  const paymentMethod = watch('payment_method')
  const paymentMethodNewProp = watch('newpropertyinfo.payment_method')
  const payeeName = watch('payee_name')
  const payeeNameNew = watch('newpropertyinfo.payee_name')
  const newPropertyName = watch('new_property_name')

  return {
    form,
    register,
    watch,
    reset,
    setValue,
    getValues,
    formState,
    trigger,
    setValueValidated,
    fkCompanyId,
    paymentMethod,
    paymentMethodNewProp,
    payeeName,
    payeeNameNew,
    newPropertyName,
  }
}

export type TransferProcessFormState = ReturnType<typeof useTransferProcessForm>
